import React from 'react'
import {Text, TextTypography} from 'wix-ui-tpa'
import {classes} from './page-title.st.css'

export const PageTitle = props => <Text typography={TextTypography.largeTitle} {...props} className={classes.root} />
